import { render, staticRenderFns } from "./DocFilterMobile.vue?vue&type=template&id=ef928fc2"
import script from "./DocFilterMobile.vue?vue&type=script&lang=js"
export * from "./DocFilterMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports